import ValidationResult from "domain/types/global/validationResult"
import { BulkOperationResponse } from "./bulkOperationResponse"

export const CAMPANHA_RESGATE_APROVAR = 'CAMPANHA_RESGATE_APROVAR'
export const CAMPANHA_RESGATE_REPROVAR = 'CAMPANHA_RESGATE_REPROVAR'
export const CAMPANHA_RESGATE_APROVAR_BULK = 'CAMPANHA_RESGATE_APROVAR_BULK'
export const CAMPANHA_RESGATE_REPROVAR_BULK = 'CAMPANHA_RESGATE_REPROVAR_BULK'

export interface AprovarPedidoState {
	mudancaStatus: ValidationResult;
	mudancaStatusBulk: BulkOperationResponse | null;
}

export interface AprovarResgateAction {
	type: typeof CAMPANHA_RESGATE_APROVAR,
	payload: ValidationResult
}

export interface ReprovarResgateAction {
	type: typeof CAMPANHA_RESGATE_REPROVAR,
	payload: ValidationResult
}

export interface AprovarResgateBulkAction {
	type: typeof CAMPANHA_RESGATE_APROVAR_BULK,
	payload: BulkOperationResponse | null
}

export interface ReprovarResgateBulkAction {
	type: typeof CAMPANHA_RESGATE_REPROVAR_BULK,
	payload: BulkOperationResponse | null
}

export type AprovarPedidoActionTypes =
	AprovarResgateAction |
	ReprovarResgateAction |
	AprovarResgateBulkAction |
	ReprovarResgateBulkAction